import axios from "axios";
import { GetInfos } from "../endpoints/information/GetInformationService";
import { SetLog, TagLogs } from "../logs/set-log";
import { SendPipeData } from "./pipefy/SendPipeData";
import { SendSharp } from "./sharpspring/SendSharp";
import { saveExternalLead } from "../v2/lead-integration";

export async function fluxUpdate(data = {}) {
  if (!data) return;

  return axios.post("/api/hooks/send-request", data);
}

/**
 * Centralizador de Hooks
 *
 * Cada Hook precisa seguir as diretrizes de parametros:
 * -> hookname: string
 * -> params: object
 */
export async function DispathHookUpdate(
  params = false // -> required -> {}
) {
  if (!params) {
    SetLog(TagLogs.error_dispath_hook_update, { data: "any params" }, false);
    return false;
  }

  // if (!params.userEmail && !params.body.origem_api) {
  //   SetLog(TagLogs.error_dispath_hook_update, { data: 'userEmail not informed' }, false)
  //   return false;
  // }

  if (!params.body) {
    SetLog(
      TagLogs.error_dispath_hook_update,
      { data: "body not informed" },
      false
    );
    return false;
  }
  // NOVA INTEGRAÇÃO - INICIO
  SetLog(TagLogs.dispath_hook_update, {
    email: params.userEmail,
    data: params.body,
  });
  
  await saveExternalLead(params?.body ?? params, {
    req: params.req,
    res: params.res,
    email: params.userEmail,
  });
  // NOVA INTEGRAÇÃO - FIM

  // PENDENTE PARA DESATIVAÇÃO ABAIXO
  
  const results = [];
  const infos = (await GetInfos())?.data?.[0]?.attributes;

  let hasError = false;
  let result;
  await Promise.all(
    enabledHooks.map(async function (hook) {
      if (isEnabledHook(hook.name, infos)) {
        try {
          result = await hook.fn(params);
        } catch (error) {
          result = false;
          results.push({
            hook: hook.name,
            status: error.message,
            data: error.message,
          });
          hasError = true;
        }

        results.push({
          hook: hook.name,
          status: result.status ?? result,
          data: result.data ?? result,
        });

        if (!result) {
          hasError = true;
        }
      }
    })
  );
  if (hasError) {
    SetLog(
      TagLogs.error_dispath_hook_update,
      {
        data: "Uma ou mais integrações de hook update falhou",
        details: results,
      },
      false
    );
  }
  return results;
}

/**
 * Verifica se o hook está habilitado na tabela de infos
 *
 * @param {*} key hook a ser verificado - 'sharpspring' | 'pipefy' | ...
 * @param {*} systemInfos {...} lista de attributes em infos table
 * @returns true se habilitado o hook, false caso contrário
 */
function isEnabledHook(key, systemInfos) {
  switch (key) {
    case "sharpspring":
      // Enviar para SharpSpring
      return systemInfos?.usa_sharpspring == true;
    case "pipefy_lead_data":
      // Enviar para Pipefy em Data Lead
      return systemInfos?.usa_pipefy == true;
    // case 'pipefy_lead_step':
    //   // Enviar para Pipefy em Step Lead
    //   return systemInfos?.usa_pipefy == true;
    default:
      // Nada a fazer
      return false;
  }
}

/**
 * Lista de Hooks integrados
 * {
 *  name: 'sharpspring' | 'pipefy' | ...
 *
 *  fn: () => any -> function que executa a integração do update
 *    -> cada function deve verificar se os params recebidos está na gama de itens atualizáveis
 *    -> cada function deve retornar true | false do resultado da operação
 * }
 */
const enabledHooks = [
  { name: "sharpspring", fn: SendSharp },
  { name: "pipefy_lead_data", fn: SendPipeData },
  // { name: 'pipefy_lead_step', fn: SendPipeStep },
];
